export const ProfileStepsCompleted = {
  InitialScreen: 0,
  InitialTutorCounsellorSelected: 1,
  TutorCounsellorPersonalDetailDone: 2,
  TutorCounsellorProfessionalDetailDone: 3,
  TutorCounsellorExpertiseDetailDone: 4,
  TutorCounsellorAvailabilityDone: 5,
  InitialStudentParentSelected: 11,
  InitialStudentParentServiceInterestAdded: 12,
  StudentDetailsInitialAddedByStudent: 13,
  ParentPersonalDetailEntered: 13, // Same value kept deliberately as same screen used
  StudentFamilyDetailsEntered: 14,
  ParentStudentDetailsEntered: 14, // Same value kept deliberately as same screen used
  StudentAcademicDetailsEntered: 15,
  SkippedAtStudentFamilyScreen: 21,
  SkippedAtStudentAcademicScreen: 22,
  ParentSkippedAtStudentDetail: 23,
  ParentSkippedAtAcademicDetail: 24
};

export const TutorCounsellorSignUpStepperIndex = {
  ProfileSetup: 1,
  ProfessionalSetup: 2,
  Expertise: 3,
  Availability: 4
};

export const StudentParentSignUpStepperIndex = {
  ProfileSetup: 1,
  ServiceOfInterestAdded: 2,
  StudentPersonalDetailAdded: 3,
  FamilyDetailsAdded: 4,
  AcademicDetail: 5
};